import styled from "styled-components";

export const Container = styled.div`
  min-height: 100%;
  overflow: hidden;
`;

export const InitialScreen = styled.div`
  height: 820px;
  background-color: #fff;
  padding: 32px;
  border-radius: 8px;
  overflow-y: auto;
`;

export const InitialContent = styled.div`
  max-width: 100%;
`;

export const MainScreen = styled.div`
  height: 51rem;
  overflow: hidden;
  background-color: #f9fafb;
  display: flex;
`;
